import React from "react";
// import { graphql, StaticQuery } from "gatsby";
// import BackgroundImage from "gatsby-background-image";
// import Image from "gatsby-image";

import { cn } from "../../utils/cn";
import CloudinaryImage from "../newVersion/CloudinaryImage"; // usa tu componente nuevo

const GenericImage = ({ filename, className, children, alt = "" }) => {
    return (
        <div className={cn("relative bg-gray-50", className)}>
            <CloudinaryImage
                filename={filename}
                className="absolute inset-0 h-full w-full object-cover"
                quality={90}
                alt={alt}
            />

            {children && (
                <div className="absolute top-0 z-10 h-full w-full">
                    {children}
                </div>
            )}
        </div>
    );
};

/*const _GenericImage = (props) => (
    <StaticQuery
        query={graphql`
            query images {
                allCloudinaryAsset {
                    nodes {
                        fluid {
                            src
                            ...CloudinaryAssetFluid
                        }
                    }
                }
            }
        `}
        render={(data) => {
            if (!data?.allCloudinaryAsset?.nodes) return null;

            const image = data.allCloudinaryAsset.nodes.find((n) => {
                const src = n?.fluid?.src;
                return src ? src.endsWith(props.filename) : false;
            });

            if (!image?.fluid) return null;

            if (props.children) {
                return (
                    <BackgroundImage
                        fluid={image.fluid}
                        className={props.className}
                        fadeIn={true}
                    >
                        {props.children}
                    </BackgroundImage>
                );
            }

            return (
                <Image
                    className={props.className}
                    alt={props.alt || ""}
                    fadeIn={true}
                    fluid={image.fluid}
                />
            );
        }}
    />
);*/

export default GenericImage;
